import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthFacade {
  readonly isAuthenticated$: Observable<boolean>;
  private _isAuthenticated = false;

  constructor(private readonly auth: AuthService) {
    this.isAuthenticated$ = this.auth.isAuthenticated$;
    this.isAuthenticated$.subscribe((val) => (this._isAuthenticated = val));
  }

  isAuthenticated(): boolean {
    return this._isAuthenticated;
  }

  login(): void {
    this.auth.loginWithRedirect();
  }

  loginToWorkspace(): void {
    this.auth.loginWithRedirect({
      appState: { target: '/workspace' },
    });
  }

  logout(): void {
    this.auth.logout({
      logoutParams: { returnTo: window.location.origin },
    });
  }
}
